export function buildGpx(feature) {
  const now = new Date().toISOString();
  const name = feature.name || '绘制路线';
  let body = `<?xml version="1.0" encoding="UTF-8"?>
<gpx version="1.1" creator="ZHXT Drawing Board" xmlns="http://www.topografix.com/GPX/1/1">
  <metadata><name>${name}</name><time>${now}</time></metadata>
  <trk><name>${name}</name><trkseg>`;
  feature.coordinates.forEach(([lng, lat]) => {
    body += `\n    <trkpt lat="${lat}" lon="${lng}"></trkpt>`;
  });
  body += `\n  </trkseg></trk>\n</gpx>`;
  return body;
}

export function buildKml(feature) {
  const name = feature.name || '绘制路线';
  const coords = feature.coordinates.map(([lng, lat]) => `${lng},${lat},0`).join(' ');
  return `<?xml version="1.0" encoding="UTF-8"?>
<kml xmlns="http://www.opengis.net/kml/2.2">
  <Document>
    <name>${name}</name>
    <Placemark>
      <name>${name}</name>
      <Style><LineStyle><color>ff0000ff</color><width>3</width></LineStyle></Style>
      <LineString><coordinates>${coords}</coordinates></LineString>
    </Placemark>
  </Document>
</kml>`;
}

export function downloadText(filename, content, mime) {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
